export default __webpack_public_path__ + "static/media/passive_income.e18630c6.svg";